// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"f12be874","333":"e06c59f7","411":"1a84076d","447":"cc5bd9a1","461":"de45040e","487":"2fbc4a0b","511":"e3d32ff8","794":"651c84b7","859":"8ec2ec00"}[chunkId] + ".chunk.js";
};